import { Container, ContainerProps } from '@chakra-ui/react';
import React from 'react';

interface Props extends ContainerProps {
  smaller?: boolean;
  isNoPaddingOnMobile?: boolean;
}

const PageContainer = ({ smaller, isNoPaddingOnMobile, ...props }: Props) => {
  return (
    <Container
      maxWidth={{ xl: smaller ? 1040 : 1290 }}
      px={{ base: isNoPaddingOnMobile ? 0 : '30px', md: 10, '2xl': 0 }}
      {...props}
    />
  );
};

export default PageContainer;
